"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const react_2 = require("@osmosys/react");
const svg_1 = require("../../../svg");
const graphql_1 = require("../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
exports.OsmosysSnap = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.OsmosysResourcePage, { paths: {
                item: 'getOsmosysSnapConnection',
            }, 
            // headerColor="danger"
            backgroundImage: "https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&h=500&q=90", getTitle: data => (react_1.default.createElement("div", { className: "text-center mt-2" },
                react_1.default.createElement(svg_1.OsmosysSnapLogo, { width: "3em", height: undefined }),
                react_1.default.createElement("div", { className: "mt-2 d-block", style: { fontSize: '36px', lineHeight: '44px' } }, "Osmosys Snap"),
                react_1.default.createElement(reactstrap_1.Card, { className: "border-0 d-inline-block text-dark p-2 mt-2" },
                    react_1.default.createElement("p", { className: "lead m-0 mb-0", style: { fontSize: 14 } },
                        react_1.default.createElement(reusables_1.ConnectionStatus, { canConnect: data.getOsmosysSnapConnection.canConnect, disconnectedText: "Cannot connect to Osmosys Snap", connectedText: "Connected", small: false, fontSize: 14 }))))), query: graphql_1.getOsmosysSnapConnection }, () => {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }),
        react_1.default.createElement(reactstrap_1.Row, null,
            react_1.default.createElement(reactstrap_1.Col, null,
                react_1.default.createElement(reusables_1.Form, { mutationProps: {
                        mutation: graphql_1.createScreenshot,
                    }, onSubmit: () => {
                        // // Poor man's polling subscription
                        // setTimeout(() => {
                        //   queryResult.refetch();
                        // }, 500);
                        // this.queryRefetchInterval = setInterval(() => {
                        //   queryResult.refetch();
                        // }, 2500);
                    }, formikProps: {
                        initialValues: {
                            dpi: 2,
                            html: '',
                            isPartial: false,
                            maxWidth: 600,
                            overlayHtml: '',
                            renderTimeout: 0.5,
                        },
                        validationSchema: Yup.object().shape({
                            html: Yup.string().required('Required'),
                            isPartial: Yup.boolean().required(),
                            maxWidth: Yup.number(),
                            overlayHtml: Yup.string(),
                            renderTimeout: Yup.number()
                                .required()
                                .min(0)
                                .max(30),
                        }),
                    }, valuesToVariables: values => {
                        const options = {
                            html: values.html,
                            isPartial: values.isPartial,
                            overlayHtml: values.overlayHtml,
                            renderTimeout: values.renderTimeout * 1000,
                        };
                        return {
                            options,
                        };
                    } }, (formikProps, result) => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(reactstrap_1.Row, null,
                        react_1.default.createElement(reactstrap_1.Col, { className: "text-center mt-4" },
                            react_1.default.createElement("h4", null, "Screenshot debugger"),
                            react_1.default.createElement("p", null, "For internal usage, testing, and for the lulz of it."))),
                    react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center my-4" },
                        react_1.default.createElement(reactstrap_1.Col, { sm: "6", md: "4", lg: "3" },
                            react_1.default.createElement(reusables_1.FormGroup, { label: "HTML", name: "html", type: "textarea", placeholder: "HTML", rows: "8" }),
                            react_1.default.createElement(reusables_1.FormGroup, { label: "Head HTML", name: "headHtml", type: "textarea", placeholder: "HTML", rows: "8" })),
                        react_1.default.createElement(reactstrap_1.Col, { sm: "6", md: "4", lg: "3" },
                            react_1.default.createElement(reusables_1.FormGroup, { label: "Overlay HTML", name: "overlayHtml", type: "textarea", placeholder: "Overlay HTML", rows: "8" }),
                            react_1.default.createElement(reusables_1.FormGroup, { label: "Included HTML", name: "includedHtml", type: "textarea", placeholder: "Included HTML", rows: "8" }))),
                    react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center my-4" },
                        react_1.default.createElement(reactstrap_1.Col, { sm: "6", md: "4", lg: "3", className: "" },
                            react_1.default.createElement(reusables_1.FormGroup, { label: "Seconds to wait before taking screenshot", name: "renderTimeout", type: "number", placeholder: "Seconds to wait", min: 0, max: 30 }),
                            react_1.default.createElement(reusables_1.FormGroup, { label: "DPI", name: "dpi", type: "number", placeholder: "DPI", min: 0, max: 30 }),
                            react_1.default.createElement(reactstrap_1.ButtonGroup, { size: "sm" },
                                react_1.default.createElement(reactstrap_1.Button, { color: "link" }, "1x (optimal for outlook)"),
                                react_1.default.createElement(reactstrap_1.Button, { color: "link" }, "2x (retina)"))),
                        react_1.default.createElement(reactstrap_1.Col, { sm: "6", md: "4", lg: "3" },
                            react_1.default.createElement("div", { className: "flex-col-centered h-100", style: { maxWidth: 120 } },
                                react_1.default.createElement(reusables_1.FormGroup, { label: "Full HTML document", name: "isPartial", type: "checkbox", rows: "8" }),
                                react_1.default.createElement(reusables_1.FormGroup, { label: "Retina", name: "isRetina", type: "checkbox", rows: "8" })))),
                    react_1.default.createElement(reactstrap_1.Row, null,
                        react_1.default.createElement(reactstrap_1.Col, { className: "text-center mb-2" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(reusables_1.AjaxButton, { size: "lg", type: "button", onClick: () => formikProps.submitForm(), label: "Screenshot", error: result.error, success: !!result.data, loading: result.loading, icon: pro_solid_svg_icons_1.faCamera }))),
                            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "HostedFile", action: "create", apolloError: result.error })))))),
                react_1.default.createElement("div", { className: "text-center mb-2" },
                    react_1.default.createElement(reusables_1.FileUploader, { ajaxButton: true, color: "link" })),
                react_1.default.createElement(react_2.OsmosysListLayout, { pathToCount: "hostedFilesCount", pathToItems: "hostedFiles", itemName: "file", itemsName: "files", query: {
                        query: graphql_1.hostedFiles,
                        variables: {},
                    }, itemProps: (data) => {
                        return {
                            artClassName: 'bg-transparent-grid-on-img p-2',
                            faProps: {
                                className: data.screenshotFailed || data.uploadToHostFailed
                                    ? 'text-danger'
                                    : undefined,
                                icon: (data.screenshotFailed || data.uploadToHostFailed
                                    ? pro_solid_svg_icons_1.faExclamationCircle
                                    : data.screenshotInProgress || data.uploadToHostInProgress
                                        ? pro_solid_svg_icons_1.faSpinnerThird
                                        : undefined),
                                spin: data.screenshotInProgress,
                            },
                            meta: `Created ${moment_1.default(data.createdAt).format('LLLL')}`,
                            thumbnailURL: data.url,
                            title: data.uploadToHostInProgress
                                ? 'Uploading to the Osmosys hosting service'
                                : data.uploadToHostFailed
                                    ? 'Upload to the Osmosys hosting service failed'
                                    : data.screenshotFailed
                                        ? 'Screenshot failed to take'
                                        : data.screenshotInProgress
                                            ? 'Taking screenshot...'
                                            : data.filename
                                                ? data.filename
                                                : 'No file name',
                        };
                    } }),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null)))));
};
exports.default = exports.OsmosysSnap;
//# sourceMappingURL=index.js.map